// SPDX-License-Identifier: AGPL-3.0-or-later

import {createBrowserHistory} from '@app/features/platform/components/router/History';
import type {HistoryAdapter} from '@app/features/platform/components/router/RouterTypes';
import {Logger} from '@app/features/platform/utils/AppLogger';

const logger = new Logger('RouterUtils');
export const history: HistoryAdapter | null = createBrowserHistory();
export function transitionTo(path: string) {
	logger.info('transitionTo', path);
	if (history) {
		const current = history.getLocation().url.pathname;
		if (current === path) return;
		history.push(new URL(path, window.location.origin));
	}
}
export function replaceWith(path: string) {
	logger.info('replaceWith', path);
	if (history) {
		const current = history.getLocation().url.pathname;
		if (current === path) return;
		history.replace(new URL(path, window.location.origin));
	}
}
export function getHistory() {
	return history;
}
